import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { StoredLevel } from '../../types/gameApi';

interface LevelCardProps {
  stored: StoredLevel;
  completed: boolean;
}

const DIFFICULTY_STYLE = {
  beginner: 'text-emerald-400 border-emerald-700/40 bg-emerald-950/20',
  intermediate: 'text-mafia-gold border-mafia-gold/40 bg-mafia-gold/5',
  advanced: 'text-mafia-crimson border-mafia-crimson/40 bg-mafia-crimson/10',
};

export function LevelCard({ stored, completed }: LevelCardProps) {
  const { t } = useTranslation('game');
  const level = stored.levelData;

  return (
    <Link to={`/game/${stored.levelId}`} className="card-vintage group block hover:border-mafia-gold/40 transition-colors">
      <div className="p-5 flex flex-col gap-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex flex-col gap-1">
            <span className={`inline-block self-start text-[9px] font-mono uppercase tracking-widest px-1.5 py-0.5 rounded border ${DIFFICULTY_STYLE[stored.difficulty]}`}>
              {t(`lobby.difficulty.${stored.difficulty}`)}
            </span>
            <h3 className="font-display text-lg text-mafia-paper group-hover:text-mafia-gold transition-colors">
              {level?.title ?? stored.title}
            </h3>
          </div>
          {completed && (
            <span className="shrink-0 text-mafia-gold text-xl" title={t('lobby.completed')}>✦</span>
          )}
        </div>

        <p className="text-xs text-mafia-muted leading-relaxed line-clamp-3">
          {level?.brief ?? ''}
        </p>

        {level && (
          <div className="flex items-center gap-3 pt-1 border-t border-mafia-border/50 flex-wrap">
            <span className="text-[10px] font-mono text-mafia-muted">{level.nights.length} ночей</span>
            <span className="text-mafia-border">·</span>
            <span className="text-[10px] font-mono text-mafia-muted">{level.days.length} дней</span>
            <span className="text-mafia-border">·</span>
            <span className="text-[10px] font-mono text-mafia-muted">{level.hints.length} подсказок</span>
            {(stored.totalCompletions ?? 0) > 0 && (
              <>
                <span className="text-mafia-border">·</span>
                <span className="text-[10px] font-mono text-mafia-gold/70">
                  ✦ {stored.totalCompletions} решений
                </span>
              </>
            )}
          </div>
        )}
      </div>
    </Link>
  );
}
